import React from 'react'
import { useSpring, animated } from 'react-spring'
import { t } from 'ttag'
import { useInView } from 'react-intersection-observer'
import { motion } from 'framer-motion'

export interface CollapseItemProps {
    contentItemId: string
    puxDesignCollapseItemColor: string
    puxDesignCollapseItemDescription: {
        html: string
    }
    puxDesignCollapseItemDisplayTitle: string
    puxDesignCollapseItemDuration: string
    puxDesignCollapseItemOutput: string
    puxDesignCollapseItemIsOptional: boolean
    puxDesignCollapseItemtOpened: boolean
    puxDesignCollapseItemNestedCollapses: {
        contentItems: [CollapseItemProps]
    }
}

const CollapseItem = (props: CollapseItemProps) => {
    const [isOpen, setOpen] = React.useState(props.puxDesignCollapseItemtOpened)

    const springAnim = useSpring({
        maxHeight: isOpen ? 400 : 0,
        from: {
            maxHeight: isOpen ? 0 : 400,
        },
    })

    const [ref, inView] = useInView({
        threshold: 0.5,
        triggerOnce: true,
    })

    const variants = {
        visible: { opacity: 1, scale: 1, x: 0 },
        hidden: {
            opacity: 0,
            x: 50,
        },
    }

    return (
        <motion.div
            ref={ref}
            className={`collapse-wrap ${props.puxDesignCollapseItemColor}${isOpen ? ` open` : ``}`}
            key={props.contentItemId}
            animate={inView ? `visible` : `hidden`}
            variants={variants}
            transition={{ duration: 1, ease: `easeOut` }}
        >
            <div className="collapse">
                <div className="collapse-title" onClick={() => setOpen(!isOpen)}>
                    {props.puxDesignCollapseItemDisplayTitle}
                    <span>{props.puxDesignCollapseItemIsOptional ? t`PuxDesign.HowDoWeWork.Optional` : ``}</span>
                </div>
                <animated.div
                    className="collapse-description"
                    style={springAnim}
                    dangerouslySetInnerHTML={{
                        __html: props.puxDesignCollapseItemDescription.html?.replace(/font-size: 1rem;/g, ``),
                    }}
                ></animated.div>
            </div>
            <div className="collapse-info">
                <div className="collapse-info-item">
                    <span className="label">{t`PuxDesign.HowDoWeWork.Duration`}</span>
                    <span className="value">{props.puxDesignCollapseItemDuration}</span>
                </div>
                <div className="collapse-info-item">
                    <span className="label">{t`PuxDesign.HowDoWeWork.Output`}</span>
                    <span className="value">{props.puxDesignCollapseItemOutput}</span>
                </div>
            </div>
            {props.puxDesignCollapseItemNestedCollapses ? (
                <div className="nested-collapses">
                    {props.puxDesignCollapseItemNestedCollapses.contentItems.map((collapse: CollapseItemProps) => (
                        <CollapseItem {...collapse} key={collapse.contentItemId} />
                    ))}
                </div>
            ) : null}
        </motion.div>
    )
}

export default CollapseItem
